import ReminderContainer from './ReminderContainer';

export default ReminderContainer;



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/ConfirmationPage/components/Reminder/index.js